import { addressFormat } from './address-format';

export const NZ = {
  validator: null,
  addressFormat,
};
